module.exports = __webpack_public_path__ + "0b87271ef346c7fbbde6b09ab00177b2.jpg";